import { SupersetClient } from '@aibi-ui/core';
import { ReportChat } from 'src/analyze-report/types';

/** 停止提问 */
export const postReportChatConversationStop = (
  jsonPayload: ReportChat.StopData,
) =>
  SupersetClient.post({
    endpoint: '/api/v1/report_chat/conversation/stop',
    jsonPayload,
  });

/** 修改报告内容 */
export const putReportChatReport = (jsonPayload: {
  report: string;
  round_id: string;
}) =>
  SupersetClient.put({
    endpoint: '/api/v1/report_chat/report',
    jsonPayload,
  });
